<template> 
  <Dialog v-model:visible="confirmDialogTrash.visible" :header="confirmDialogTrash.isNew ? 'Nuovo Banner' : 'Modifica Banner'" :modal="true" :style="{ width: '500px' }" class="p-fluid">
    <div class="field mb-3">
      <label for="banner-title" class="font-bold">Titolo (opzionale)</label>
      <InputText id="banner-title" v-model="confirmDialogTrash.title" placeholder="Inserisci il titolo" />
    </div>

    <div class="field mb-3">
      <label for="banner-label" class="font-bold">Azione (Label)</label>
      <Dropdown id="banner-label" v-model="confirmDialogTrash.label" :options="labelOptions" optionLabel="name" optionValue="value" placeholder="Seleziona l'azione (Label)" />
    </div>

    <div class="field mb-3" v-if="confirmDialogTrash.label === 'Link Esterno' || confirmDialogTrash.label === 'Link esterno' || confirmDialogTrash.label === 'url'">
      <label for="banner-link" class="font-bold">Link Esterno (URL)</label>
      <InputText id="banner-link" v-model="confirmDialogTrash.link" placeholder="Es. https://www.example.com" />
    </div>

    <div class="field mb-3">
      <label class="font-bold block mb-2">Immagine Banner</label>
      <div class="flex flex-column gap-2">
        <div v-if="imagePreviewUrl" class="image-preview text-center p-2 border-1 surface-border border-round">
          <img :src="imagePreviewUrl" alt="Preview" class="preview-img" style="max-width: 100%; max-height: 180px; object-fit: contain;" />
        </div>
        <div v-else class="text-center p-3 surface-200 border-round text-500">
          Nessuna immagine selezionata
        </div>

        <div class="flex align-items-center gap-2 mt-2">
          <FileUpload mode="basic" chooseLabel="Seleziona file" accept="image/*" :customUpload="true" @select="onImageSelect" class="p-button-outlined" />
          <span v-if="confirmDialogTrash.imageFile" class="text-sm text-green-600 font-semibold truncate">
            <i class="pi pi-file mr-1"></i>{{ confirmDialogTrash.imageFile.name }}
          </span>
        </div>
      </div>
    </div>

    <div class="field mb-3">
      <label for="banner-ordine" class="font-bold">Ordine di visualizzazione</label>
      <InputNumber id="banner-ordine" v-model="confirmDialogTrash.ordine" placeholder="Es. 1, 2, 3..." :min="0" />
    </div>

    <div class="field-checkbox mb-3 flex align-items-center gap-2">
      <InputSwitch id="banner-visibile" v-model="confirmDialogTrash.visibile" />
      <label for="banner-visibile" class="font-bold mb-0">Visibile in App</label>
    </div>

    <template #footer>
      <Button label="Annulla" icon="pi pi-times" class="p-button-text p-button-secondary" @click="confirmDialogTrashReject" />
      <Button label="Salva" icon="pi pi-check" class="p-button-primary" @click="confirmDialogTrashAccept" />
    </template>
  </Dialog>

  <Loader v-if="loading" />    
  <Card>
    <template v-slot:title>
      <div class="flex justify-content-between align-items-center">
        <h3>Gestione Banner App</h3>
        <Button label="Nuovo Banner" icon="pi pi-plus" @click="openNewDialog" />
      </div>
    </template>
    <template v-slot:content>
      <div class="col-12 flex flex-column md:col-12">
        <table>
          <thead>
            <tr>
              <th>Titolo</th>
              <th>Label (Azione)</th>
              <th>Link Esterno</th>
              <th style="width: 80px;">Ordine</th>
              <th style="width: 200px;">Immagine</th>
              <th style="width: 100px;">Visibile</th>
              <th style="width: 100px;"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="n in banners" :key="n.id">
              <td>{{ n.title }}</td>
              <td>{{ n.label }}</td>
              <td>
                <a v-if="n.link" :href="n.link" target="_blank" class="text-sm font-semibold text-blue-600 truncate block" style="max-width: 180px;">{{ n.link }}</a>
                <span v-else class="text-400">-</span>
              </td>
              <td style="text-align: center; font-weight: bold;">{{ n.ordine }}</td>
              <td style="text-align: center;">
                <img v-if="n.img" :src="getImageUrl(n.img)" alt="Image" style="max-width: 200px; max-height: 200px;" />
              </td>
              <td>
                <InputSwitch :modelValue="n.visibile == 1" @change="toggleVisibility(n)" />
              </td>
              <td>
                <Button @click="openConfirmDialogTrash(n)" class='p-button-warning mr-2'><i class='pi pi-pencil'></i></Button>
                <Button @click="deleteBanner(n.id)" class='p-button-danger'><i class='pi pi-trash'></i></Button>
              </td>
            </tr>
            <tr v-if="banners.length === 0">
              <td colspan="7" class="text-center">Nessun banner trovato.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
  </Card>
</template>

<script>
import { ref, onMounted, getCurrentInstance, computed } from 'vue';
import Loader from "@/components/Loader.vue"
import Service from '@/services/levante-api/levante-api'
import { useToast } from 'primevue/usetoast';

export default {
  components: {
    Loader,
  },
  
  setup () { 
    const self = getCurrentInstance();
    const toast = useToast();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    const service = new Service(self.$eventBus)
    const loading = ref(false)
    const banners = ref([]);
    const lifeTime = 3000;

    const labelOptions = ref([
      { name: 'Scuola calcio', value: 'Scuola calcio' },
      { name: 'Senior (Home)', value: 'Senior' },
      { name: 'Shop', value: 'Shop' },
      { name: 'Fisio', value: 'Fisio' },
      { name: 'Personal', value: 'Personal' },
      { name: 'Doctor', value: 'Doctor' },
      { name: 'Contatti', value: 'Contatti' },
      { name: 'Feste', value: 'Feste' },
      { name: 'Studio', value: 'Studio' },
      { name: 'Estivo', value: 'Estivo' },
      { name: 'Summer', value: 'Summer' },
      { name: 'Nessuna Azione', value: '' }
    ]);

    const loadVisiteTypes = async () => {
      try {
        const res = await service.getTypeVisita();
        const items = (res && res.items) ? res.items : (Array.isArray(res) ? res : []);
        const baseOptions = [
          { name: 'Link Esterno (URL)', value: 'Link Esterno' },
          { name: 'Scuola calcio', value: 'Scuola calcio' },
          { name: 'Senior (Home)', value: 'Senior' },
          { name: 'Shop', value: 'Shop' },
          { name: 'Contatti', value: 'Contatti' },
          { name: 'Feste', value: 'Feste' },
          { name: 'Studio', value: 'Studio' },
          { name: 'Estivo', value: 'Estivo' },
          { name: 'Summer', value: 'Summer' },
        ];
        
        // Add visit types dynamically from DB
        const visitOptions = items.map(v => ({
          name: `Prenotazione: ${v.nome}`,
          value: v.nome
        }));
        
        // Short alias helpers
        const aliases = [
          { name: 'Prenotazione: Fisio', value: 'Fisio' },
          { name: 'Prenotazione: Personal', value: 'Personal' }
        ];

        // Combine and eliminate duplicates by value
        const all = [...baseOptions, ...visitOptions, ...aliases, { name: 'Nessuna Azione', value: '' }];
        const unique = [];
        const seen = new Set();
        for (const opt of all) {
          if (!seen.has(opt.value)) {
            seen.add(opt.value);
            unique.push(opt);
          }
        }
        labelOptions.value = unique;
      } catch (err) {
        console.error("Errore nel caricamento delle tipologie visita:", err);
      }
    };

    const confirmDialogTrash = ref({
      visible: false,
      isNew: false,
      id: null,
      visibile: true,
      title: '',
      label: '',
      link: '',
      ordine: 0,
      imageFile: null,
      existingImage: null
    });

    const getImageUrl = (imgPath) => {
      return `${process.env.VUE_APP_LEVANTE_API_URL}/../storage/app/public/${imgPath}`;
    }

    const imagePreviewUrl = computed(() => {
      if (confirmDialogTrash.value.imageFile) {
        return URL.createObjectURL(confirmDialogTrash.value.imageFile);
      } else if (confirmDialogTrash.value.existingImage) {
        return getImageUrl(confirmDialogTrash.value.existingImage);
      }
      return null;
    });

    const onImageSelect = (event) => {
      if (event.files && event.files.length > 0) {
        confirmDialogTrash.value.imageFile = event.files[0];
      } else if (event.target && event.target.files && event.target.files.length > 0) {
        confirmDialogTrash.value.imageFile = event.target.files[0];
      }
    };

    const openNewDialog = () => {
      confirmDialogTrash.value = {
        visible: true,
        isNew: true,
        id: null,
        visibile: true,
        title: '',
        label: '',
        link: '',
        ordine: 0,
        imageFile: null,
        existingImage: null
      };
    };

    const openConfirmDialogTrash = (banner) => {
      confirmDialogTrash.value = {
        visible: true,
        isNew: false,
        id: banner.id,
        visibile: banner.visibile == 1,
        title: banner.title || '',
        label: banner.label || '',
        link: banner.link || '',
        ordine: banner.ordine || 0,
        imageFile: null,
        existingImage: banner.img
      };
    };

    const confirmDialogTrashAccept = () => {
      if (!confirmDialogTrash.value.imageFile && !confirmDialogTrash.value.existingImage) {
        toast.add({ severity: 'error', summary: 'Errore', detail: 'Immagine obbligatoria', life: lifeTime });
        return;
      }
      saveBanner();
    };

    const confirmDialogTrashReject = () => {
      confirmDialogTrash.value.visible = false;
    };

    const toggleVisibility = async (banner) => {
      try {
        await service.setBannerVisibile(banner.id, { visibile: banner.visibile == 1 ? 0 : 1 });
        toast.add({ severity: 'success', summary: 'Successo', detail: 'Visibilità aggiornata', life: lifeTime });
        initData();
      } catch (error) {
        toast.add({ severity: 'error', summary: 'Errore', detail: 'Impossibile aggiornare visibilità', life: lifeTime });
      }
    };

    const deleteBanner = async (id) => {
      if (confirm("Vuoi davvero eliminare questo banner?")) {
        try {
          await service.delBanner(id);
          toast.add({ severity: 'success', summary: 'Successo', detail: 'Banner eliminato', life: lifeTime });
          initData();
        } catch (error) {
          toast.add({ severity: 'error', summary: 'Errore', detail: 'Impossibile eliminare banner', life: lifeTime });
        }
      }
    };

    const saveBanner = async () => {
      loading.value = true;
      try {
        let fd = new FormData();
        fd.append("title", confirmDialogTrash.value.title || '');
        fd.append("label", confirmDialogTrash.value.label || '');
        fd.append("link", confirmDialogTrash.value.link || '');
        fd.append("ordine", confirmDialogTrash.value.ordine || 0);
        fd.append("visibile", confirmDialogTrash.value.visibile ? 1 : 0);
        
        if (confirmDialogTrash.value.imageFile) {
          fd.append("image", confirmDialogTrash.value.imageFile);
        }
        
        if (confirmDialogTrash.value.isNew) {
          await service.addBanner(fd);
        } else {
          fd.append("id", confirmDialogTrash.value.id);
          await service.editBanner(fd);
        }

        toast.add({ severity: 'success', summary: 'Successo', detail: 'Banner salvato', life: lifeTime });
        confirmDialogTrash.value.visible = false;
        initData();
      } catch (error) {
        toast.add({ severity: 'error', summary: 'Errore', detail: 'Errore durante il salvataggio', life: lifeTime });
      } finally {
        loading.value = false;
      }
    };

    const initData = () => {
      loadVisiteTypes();
      service.getBannersApp().then((res) => {
        banners.value = res.items || res;
      }).catch(() => {
        toast.add({ severity: 'error', summary: 'Errore', detail: 'Impossibile caricare i banner', life: lifeTime });
      });
    }

    onMounted(() => { 
      loading.value = true
      initData();
      loading.value = false;
    })
    
    return {
      loading,
      banners,
      labelOptions,
      confirmDialogTrash,
      imagePreviewUrl,
      onImageSelect,
      onImageChange: onImageSelect,
      openNewDialog,
      openConfirmDialogTrash,
      confirmDialogTrashReject,
      confirmDialogTrashAccept,
      toggleVisibility,
      deleteBanner,
      getImageUrl
    }
  },
}
</script>

<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  border: 1px solid #ddd;
  padding: 8px;
}

th {
  background-color: #f2f2f2;
}
</style>

